"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function useRoute() {
    function routeWrapper(name, params, absolute) {
        return window.route(name, params, absolute);
    }
    return routeWrapper;
}
exports.default = useRoute;
